import { render, staticRenderFns } from "./KYCWallet.vue?vue&type=template&id=080521b1&scoped=true&"
import script from "./KYCWallet.vue?vue&type=script&lang=js&"
export * from "./KYCWallet.vue?vue&type=script&lang=js&"
import style0 from "./KYCWallet.vue?vue&type=style&index=0&id=080521b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080521b1",
  null
  
)

export default component.exports